import {
  createApiClient
} from '../../api-client';

export const apiRequest = createApiClient(
  process.env.NEXT_PUBLIC_BMS_API_BASE_URL ?? '/api/bms',
  process.env.BMS_API_BASE_URL_INTERNAL
);
